import { shuffle } from '../utilities'
import i18n from '../../../utilities/translation'
import { refreshVisibleAds } from '../utilities/ad_behaviors'
import ga4RevealWidgetClickHandler from '../ga4_support/blocks/reveal_widget'
import { isMomentTheme } from '../shared/templates/utils'
import GA4Handler from '../ga4_support/GA4Handler'

const language = document.documentElement.lang
const appTheme = document.documentElement.getAttribute('data-mp-app-theme')

const getFooterText = () => {
  const text = isMomentTheme(appTheme) ? 'Tap to reveal!' : 'Tap to for more advice.'
  return i18n(text, language)
}

const BASE_CLICK_TEXT = getFooterText()
const BASE_REFRESH_TEXT = i18n('Tap to reveal another advice.', language)

const showBlock = array => {
  array.forEach(block => {
    const { el, disappearClass, appearClass } = block

    el.setAttribute('tabindex', '0')
    el.removeAttribute('aria-hidden')
    el.classList.remove(disappearClass)
    el.classList.add(appearClass)
  })
}

const hideBlock = array => {
  array.forEach(block => {
    const { el, disappearClass, appearClass } = block

    el.setAttribute('tabindex', '-1')
    el.setAttribute('aria-hidden', 'true')
    el.classList.remove(appearClass)
    el.classList.add(disappearClass)
  })
}

const initAdviceOfDayBlock = (container: HTMLElement, items: string[]) => {
  let displayCount = 0
  let unseenContent = shuffle(items)
  let isRevealed = false

  const innerContainer = container.querySelector('.block-item--advice-of-day') as HTMLElement
  const contentContainer = container.querySelector('.block-widget-reveal__content') as HTMLElement
  const bannerContainer = container.querySelector(
    '.block-item-main-banner-container'
  ) as HTMLElement
  const mainBannerFooterText = container.querySelector(
    '.block-item-main-banner-footer-text'
  ) as HTMLElement
  const smallBannerContainer = container.querySelector(
    '.block-item-small-banner-container'
  ) as HTMLElement
  const activeRegion = container.querySelector('.reveal-widget__dialog-region')
  const heading = container.querySelector('.block-item-heading') as HTMLElement
  const footer = container.querySelector('.block-item-footer') as HTMLElement
  const actionButtons = container.querySelector('.block-item__actions') as HTMLElement
  const adviceText = container.querySelector('.block-item-main-banner-title') as HTMLElement

  GA4Handler.impressionHandleEvent(container as HTMLElement, {
    title: heading.innerText
  })
  container.setAttribute('data-gtm-share-text', 'advice not revealed')

  const mainBannerAndFooter = [
    {
      el: bannerContainer,
      disappearClass: 'mainBannerDisappear',
      appearClass: 'mainBannerAppear'
    },
    {
      el: footer,
      disappearClass: 'footerDisappear',
      appearClass: 'footerAppear'
    },
    {
      el: actionButtons,
      disappearClass: 'footerDisappear',
      appearClass: 'footerAppear'
    }
  ]

  const smallBannerAndHeader = [
    {
      el: smallBannerContainer,
      disappearClass: 'smallBannerDisappear',
      appearClass: 'smallBannerAppear'
    },
    {
      el: heading,
      disappearClass: 'smallBannerDisappear',
      appearClass: 'smallBannerAppear'
    }
  ]

  const showMessage = () => {
    hideBlock(smallBannerAndHeader)
    showBlock(mainBannerAndFooter)
    container.setAttribute('data-gtm-feature', 'refresh')
  }

  const hideMessage = () => {
    hideBlock(mainBannerAndFooter)
    showBlock(smallBannerAndHeader)
    container.setAttribute('data-gtm-share-text', 'advice not revealed')
    container.setAttribute('data-gtm-share-advice-text', 'advice not revealed')
    container.setAttribute('data-gtm-feature', 'show')
  }

  const updateMessage = (message = '') => {
    adviceText.innerHTML = message
    container.setAttribute('data-gtm-event-label', message)
    container.setAttribute('data-gtm-share-advice-text', message)
    container.setAttribute('data-gtm-share-text', message)
  }

  const refreshAdvice = advice => {
    updateMessage(advice)
    container.setAttribute('data-mp-share-advice-text', `${advice}`)
    container.setAttribute('data-gtm-share-text', `${advice}`)
  }

  let isClickedOnce = false
  const refreshContent = () => {
    if (!isClickedOnce) {
      innerContainer.removeAttribute('aria-label')
      innerContainer.setAttribute('aria-labelledby', 'advice-of-day__dialog-region')
      isClickedOnce = true
    }

    if (!isRevealed) {
      if (!unseenContent.length) {
        unseenContent = shuffle(items)
      }

      const freshAdvice = unseenContent.pop()
      refreshAdvice(freshAdvice)

      mainBannerFooterText.innerHTML = `\n\n ${BASE_CLICK_TEXT}`
      activeRegion.innerHTML = freshAdvice + '\n\n' + BASE_REFRESH_TEXT

      showMessage()
      ga4RevealWidgetClickHandler(
        container,
        'editorial',
        'show',
        freshAdvice,
        freshAdvice,
        ++displayCount
      )
      refreshVisibleAds()
    } else {
      activeRegion.innerHTML = BASE_CLICK_TEXT
      updateMessage()
      hideMessage()
      ga4RevealWidgetClickHandler(container, 'editorial', 'refresh', '', '')
    }
    isRevealed = !isRevealed
  }

  contentContainer.addEventListener('click', refreshContent)
  contentContainer.addEventListener('keyup', (e: any) => {
    if (e.type !== 'keyup') {
      return
    }
    if (['Enter', ' '].includes((e as any).key)) {
      refreshContent()
    }
  })
}

export default initAdviceOfDayBlock
